/** API route map: URLS.Controller.JobAttachment */
export const JobAttachment = {
      Name: 'JobAttachment/',
      GetAll: 'job-attachments',
      Add: 'add',
      DeleteAttachment: 'delete',
      ShareJobAttachment: 'share',
};
